import React from 'react';
import ProposalSelector from './ProposalSelector';

const proposalSelectorConfig = {
  label: 'Choix',
  defaultProps: { options: [], selectorStyleId: null, selectorStyles: [] },
  fields: {},
  render: ({ id, options, selectorStyleId, selectorStyles }) => (
    <ProposalSelector
      id={id}
      options={options}
      selectorStyleId={selectorStyleId}
      selectorStyles={selectorStyles}
    />
  ),
};

export default proposalSelectorConfig;
